import React from "react"

import PropTypes from "prop-types"

import "./ContentWithTitle.scss"

const ContentWithTitle = ({ section }) => {
  return (
    <section className="content-with-title">
      <h2 className="content-with-title__title">
        {section.title || "Lorem Ipsum"}
      </h2>
      <p className="content-with-title__subtitle">
        {section.subtitle || "Lorem Ipsum subtitle"}
      </p>
      <p className="content-with-title__body">
        {section.body ||
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore"}
      </p>
    </section>
  )
}

ContentWithTitle.propTypes = {
  section: PropTypes.object.isRequired,
}

export default ContentWithTitle
